<template>
  <div class="background">
    <div class="largehead">
      <div class="headcenter">
        <div class="logoname">
          <img class="headcenterimg" src="@/assets/images/largescreen/logo.png">
        </div>
        <div class="logoname">
          <div class="loginnameitem">领航智造大数据中心</div>
        </div>
      </div>
      <div class="weather">
        <div class="date">{{currentdate}}</div>
        <div class="week">{{currentweek}}</div>
        <!-- <div class="icon">
          <img src="@/assets/images/largescreen/sun.png">
        </div>
        <div class="temperature">0°C</div> -->
      </div>

    </div>
    <div class="largebody">
      <div class="side">
        <div class="item">
          <div style="width: 100%">
            <div class="title">
              <span class="name">在线/离线/库存</span>
              <!-- <span class="more">查看更多&gt;</span> -->
            </div>
            <div class="panel">
              <div class="zxtj">
                <img class="lefttop" src="@/assets/images/largescreen/jiao.png">
                <img class="righttop" src="@/assets/images/largescreen/jiao.png">
                <img class="leftbottom" src="@/assets/images/largescreen/jiao.png">
                <img class="rightbottom" src="@/assets/images/largescreen/jiao.png">
                <div class="zxtjcontent">
                  <div class="txt1">在线统计</div>
                  <div class="txt2">{{charts1online}}</div>
                  <div class="txt1">台</div>
                </div>
              </div>
              <div class="lcharts">
                <div class="cc">
                  <div class="pie border">
                    <div class="process">
                      <div style="width: 100%;height: 100%" id="pie1"></div>
                    </div>
                    <div class="piename">在线</div>
                    <div class="piecount"><span class="number">{{charts1online}}</span>台</div>
                  </div>
                  <div class="pie border">
                    <div class="process">
                      <div style="width: 100%;height: 100%" id="pie2"></div>
                    </div>
                    <div class="piename">离线</div>
                    <div class="piecount"><span class="number">{{charts1offline}}</span>台</div>
                  </div>
                  <div class="pie">
                    <div class="process">
                      <div style="width: 100%;height: 100%" id="pie3"></div>
                    </div>
                    <div class="piename">未激活</div>
                    <div class="piecount"><span class="number">{{charts1notactive}}</span>台</div>
                  </div>
                </div>
                <!-- <div class="c">
                  <div style="width: 100%;height: 100%" id="line1"></div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
 <div class="item">
          <div style="width: 100%">
            <div class="title">
              <span class="name">点位销售排行</span>
              <!-- <span class="more">查看更多&gt;</span> -->
            </div>
            <div class="panel">
              <div class="rank1">
                <div class="top1">
                  <div class="line1">
                    <div class="col11" >
                      <div class="ranki" >
                        <div class="icon11" ></div>
                        <!-- <div class="icon12" ></div> -->
                        <div class="rcontent1">
                          <div class="p">
                            <div class="rtitle1">{{firstEquipName}}</div>
                            <div class="rvalue1"><span class="num">{{firstEquipCount}}</span>&nbsp;杯</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="bottom1">
                  <div style="width: 100%;height: 100%" id="line33"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
 <div class="item">
          <div style="width: 100%">
            <div class="title">
              <span class="name">饮料销售排行</span>
              <!-- <span class="more">查看更多&gt;</span> -->
            </div>
            <div class="panel">
              <div class="rank1">
                <!-- <div class="top1">

                  <div class="line1">

                    <div class="col11" >
                      <div class="ranki" >
                        <div class="icon11" ></div>
                        <div class="rcontent1">
                          <div class="p">
                            <div class="rtitle1">{{firstBevarageName}}</div>
                            <div class="rvalue1"><span class="num">{{firstBevarageCount}}</span>&nbsp;杯</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div> -->
                <div class="top">
                  <div class="line1">
                    <div class="col1" v-for="(item,index) in charts4rank" :key="index">
                      <div class="ranki" v-if="index<4">
                        <div class="icon1" :class="'r'+(index+1)"></div>
                        <div class="rcontent">
                          <div class="p">
                            <div class="rtitle">{{item.beverage.name}}</div>
                            <div class="rvalue"><span class="num">{{item.count}}</span>杯</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="bottom1">
                  <div style="width: 100%;height: 100%" id="line333"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="item2" style="position: relative">
          <div style="width: 100%;height:100%;position: relative;overflow: hidden">
            <div class="outside" style="width: 100%;height:100%;position: relative;z-index: 1" id="map1"></div>
            <div class="animate" v-for="(item,index) in maplist" :key="index" style="box-shadow:0 0 5px 5px rgba(255,255,0,0.4);border:2px solid #39a0f1;border-radius: 35px;position:absolute;background-color: rgba(7,105,188,0.8);z-index: 2" :style="{left:(item.x-30)+'px',top:(item.y-60)+'px'}">
              <img  style="width: 60px;height: 60px;border-radius: 30px" :src="item.src">
            </div>
          </div>

          <div class="static">
            <div class="s">
              <div class="sname">在线设备</div>
              <div class="snum">

                <!-- <div class="sc" v-if="(onlinenumber+'').length==8">{{Math.floor(onlinenumber/10000000)%10}}</div>
                <div class="sc" v-if="(onlinenumber+'').length==7">{{Math.floor(onlinenumber/1000000)%10}}</div>
                <div class="sc" v-if="(onlinenumber+'').length==6">{{Math.floor(onlinenumber/100000)%10}}</div>
                <div class="sc" v-if="(onlinenumber+'').length==5">{{Math.floor(onlinenumber/10000)%10}}</div>
                <div class="sc" v-if="(onlinenumber+'').length==4">{{Math.floor(onlinenumber/1000)%10}}</div>
                <div class="sc" v-if="(onlinenumber+'').length==3">{{Math.floor(onlinenumber/100)%10}}</div>
                <div class="sc" v-if="(onlinenumber+'').length==2">{{Math.floor(onlinenumber/10)%10}}</div> -->
                <div class="sc">{{onlinenumber}}&nbsp;台</div>
              </div>
            </div>
            <!--            <div class="s">-->
            <!--              <div class="sname">离线</div>-->
            <!--              <div class="snum">-->
            <!--                <div class="sc">{{Math.floor(offlinenumber/100)%10}}</div>-->
            <!--                <div class="sc">{{Math.floor(offlinenumber/10)%10}}</div>-->
            <!--                <div class="sc">{{offlinenumber%10}}</div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="s">-->
            <!--              <div class="sname">售出杯数</div>-->
            <!--              <div class="snum">-->
            <!--                <div class="sc">{{Math.floor(salenumber/100)%10}}</div>-->
            <!--                <div class="sc">{{Math.floor(salenumber/10)%10}}</div>-->
            <!--                <div class="sc">{{salenumber%10}}</div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="s">
              <div class="sname">{{$t('equipmentmanagement.totalCups')}}</div>
              <div class="snum">
                <!-- <div class="sc" v-if="(totalnumber+'').length==8">{{Math.floor(totalnumber/10000000)%10}}</div>
                <div class="sc" v-if="(totalnumber+'').length==7">{{Math.floor(totalnumber/1000000)%10}}</div>
                <div class="sc" v-if="(totalnumber+'').length==6">{{Math.floor(totalnumber/100000)%10}}</div>
                <div class="sc" v-if="(totalnumber+'').length==5">{{Math.floor(totalnumber/10000)%10}}</div>
                <div class="sc" v-if="(totalnumber+'').length==4">{{Math.floor(totalnumber/1000)%10}}</div>
                <div class="sc" v-if="(totalnumber+'').length==3">{{Math.floor(totalnumber/100)%10}}</div>
                <div class="sc" v-if="(totalnumber+'').length==2">{{Math.floor(totalnumber/10)%10}}</div> -->
                <div class="sc">{{totalnumber}}&nbsp;杯</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="gtable" style="width: 100%;height: 100%;padding: 20px">
            <img class="lefttop" src="@/assets/images/largescreen/jiao.png">
            <img class="righttop" src="@/assets/images/largescreen/jiao.png">
            <img class="leftbottom" src="@/assets/images/largescreen/jiao.png">
            <img class="rightbottom" src="@/assets/images/largescreen/jiao.png">
            <div class="ctitle">饮品类别销售统计</div>
            <div style="width: 100%;height: calc(100% - 2rem);" id="line7"></div>
          </div>
        </div>
      </div>
      <div class="side">
        <div class="item">
          <div style="width: 100%">
            <div class="title">
              <span class="name">原料销售排行</span>
              <!-- <span class="more">查看更多&gt;</span> -->
            </div>
            <div class="panel">
              <div class="rank1">
                <div class="top">
                  <div class="line1">
                    <div class="col1" v-for="(item,index) in chartnews4rank" :key="index">
                      <div class="ranki" v-if="index<4">
                        <div class="icon1" :class="'r'+(index+1)"></div>
                        <div class="rcontent">
                          <div class="p">
                            <div class="rtitle">{{item.rawMaterial.name}}</div>
                            <div class="rvalue"><span class="num">{{(item.amount/1000).toFixed(2)}}</span>kg</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="bottom1">
                  <div style="width: 100%;height: 100%" id="line2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div style="width: 100%">
            <div class="title">
              <span class="name">杯型销售情况</span>
              <!-- <span class="more">查看更多&gt;</span> -->
            </div>
            <div class="panel">
              <div class="rank2">
                <div class="rright2">

                  <div class="rankr2">
                    <div style="width: 100%;height:100%" id="rado"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div style="width: 100%">
            <div class="title">
              <span class="name">设备故障统计</span>
            </div>
            <div class="panel">
              <div class="rank1">
                 <div class="top1">
                  <div class="line1">
                    <div class="col12" >
                      <div class="ranki" >
                        <div class="icon12a" ></div>
                        <!-- <div class="icon12" ></div> -->
                        <div class="rcontent2">
                          <div class="p">
                            <div class="rtitle1">运维故障</div>
                            <div class="rvalue1"><span class="num">{{queshuiFault+quefenFault+jspmFault+jbccleanFault+elseyunweiFault}}</span>&nbsp;件</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col12" >
                      <div class="ranki" >
                        <div class="icon12b" ></div>
                        <!-- <div class="icon12" ></div> -->
                        <div class="rcontent2">
                          <div class="p">
                            <div class="rtitle1">设备故障</div>
                            <div class="rvalue1"><span class="num">{{jiqiFault}}</span>&nbsp;件</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bottom1">
                  <div style="width: 100%;height: 100%" id="baojing"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import  'echarts/extension/bmap/bmap'
  import result from "../utils/testdata";
  import  "../utils/signalr.js";

  export default {
    name: "largeScreen.vue",
    data () {
      return {
        charts1online:0,
        charts1offline:0,
        charts1notactive:0,
        activeEquip:[],
        saleCount1:[],
        charts4rank:[],
        chartnews4rank:[],
        maplist:[],
        onlinenumber:0,
        offlinenumber:0,
        salenumber:0,
        totalnumber:0,
        numbermove1:null,
        saleList:[],
        saleRankList:[],
        areaRankList:[],
        salewaylist:[],
        totalsale:0,
        currentdate:'',
        currentweek:'',
        firstBevarageName:'',
        firstBevarageCount:0,
        firstEquipName:'',
        firstEquipCount:0,
        catalog1:[],
        catalog2:[],
        catalog3:[],
        catalog4:[],
        catalog1data:[],
        catalog2data:[],
        catalog3data:[],
        catalog4data:[],
        average:[],
        faultInfoList:[],
        queshuiFault:0,
        quefenFault:0,
        jspmFault:0,
        jbccleanFault:0,
        elseyunweiFault:0,
        jiqiFault:0
      }
    },
    created() {
    },
    mounted() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      this.currentdate = year+ '-' + month + '-' + day;
      let weekmap = {
        0:'礼拜天',
        1:'礼拜一',
        2:'礼拜二',
        3:'礼拜三',
        4:'礼拜四',
        5:'礼拜五',
        6:'礼拜六'
      }
      this.currentweek = weekmap[date.getDay()]


      //先实例化连接对象
      var connection = new signalR.HubConnectionBuilder().withUrl("/signalrhub").build();


      //setInterval(()=>{
      this.$httpservice.get("api/Analysis/CountOfIndividualEquipmentState").then(
        (res) => {
          if(res.body.code=="200"){
            this.onlinenumber = res.body.data.online
          }else{
            this.$message({
              message: data.body.msg,
              type: 'warning'
            });
          }
        },
        (data) => {
          let statusCode = data.status;
          this.$message({
            message: this.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );

      this.$httpservice.get("api/Analysis/SaleData").then(
        (res2) => {
          if(res2.body.code=="200"){
            this.totalnumber = res2.body.data.totalCupCount
          }else{
            this.$message({
              message: res2.body.msg,
              type: 'warning'
            });
          }
        },
        (data) => {
          let statusCode = data.status;
          this.$message({
            message: this.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      )
      let ttimer
      //},2000)
      //接收服务器发来的消息（注册事件）
      connection.on("ReceiveMessage",  (message)=> {
        clearTimeout(ttimer)
        this.totalnumber+=1
        let d = message.content
        //console.log(d)
        let list = []
        let map1 = this.$echarts.init(document.getElementById('map1'))
        let bmap = map1.getModel().getComponent('bmap').getBMap()
        let ll = [d.lng, d.lat]
        let point =  new BMap.Point(ll[0], ll[1]);
        let bp = bmap.pointToPixel(point)
        let dindex = Math.floor(Math.random()*9)
        if(d.picture == null){
          list.push({
            x:bp.x,
            y:bp.y,
            src:'https://icloud.lhcoffeetime.com/Uploads/2021-12-13/637749823890948258.png',
            index:1
          })
        }else{
          list.push({
            x:bp.x,
            y:bp.y,
            src:'https://icloud.lhcoffeetime.com/'+d.picture,
            index:1
          })
        }

        this.maplist = []
        setTimeout(()=>{
          this.maplist = list
        },0)
        ttimer=setTimeout(()=>{
          this.maplist = []
        },2000)
      });

      var userid = this.$account.data.id.toString();
      //初始化，建立通讯
      connection.start().then(function () {
        //document.getElementById("sendButton").disabled = false;

        //连接服务器（注册点击事件）
        // document.getElementById("connectButton").addEventListener("click", function (event) {
        //在这个例子中是取输入框（userInput）的内容，实际项目里面是取登录账号的id（注意需转化成string类型）
        if(userid){
          connection.invoke("Connect", userid).catch(function (err) {
            alert('connect err')
          });
          console.log("连接成功");
        }else{
          alert("请输入用户");
        }
      }).catch(function (err) {
        console.log("连接失败");
        let errStr = err.toString();
        return console.error(errStr);
      });

      // this.$httpservice.get("api/Analysis/SaleCountMonthly").then(res=>{
      //   res.body.data.forEach(e=>{
      //     this.saleCount1.push(e.count)
      //   })
      //   console.log(this.saleCount1)
      //   this.initcharts7()
      // })

      // this.$httpservice.get("api/Analysis/EquipmentActivateCountMonthly").then(res=>{
      //   res.body.data.forEach(e=>{
      //     this.activeEquip.push(e.count)
      //   })
      //   //console.log(this.activeEquip)
      //   this.setLine1()
      // })
      // this.initcharts1()
      this.loadcharts1()
      // this.initcharts2()
      this.loadcharts2()
      // this.initcharts3()
      this.loadcharts3()
      // this.initcharts4()
      // this.loadcharts4()
      this.loadchartnews4()
      // this.initcharts5()
      this.loadcharts7()
      // this.initcharts8()
      this.loadcharts8()
      this.loadFaultInfoCount()
      this.loadCupRado();
      window.onresize = ()=>{
        this.maplist = []
      }
    },
    methods:{
      loadcharts8(){
        this.$httpservice.get("api/Analysis/AllEquipmentPoints").then(
          (res) => {
            if(res.body.code=="200"){
              setTimeout(()=>{
                this.initcharts8(res.body)
              },0)
            }else{
              this.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          (data) => {
            let statusCode = data.status;
            this.$message({
              message: this.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
       initcharts8(resdata){
        let res = resdata
        let d = []
        let d2 = []
        for(let i in res.data){
          d.push({
            value:[res.data[i].lng,res.data[i].lat,res.data[i].id,res.data[i].network]
          })
        }
        let index =Math.floor(Math.random()*d.length)
        let d3 = d[index]
        d2 = [d3]
        let d5 = []
        for(let i in d){
          d5.push([d[i].value[0],d[i].value[1],1])
        }
        //console.log(d)
        let map1 = this.$echarts.init(document.getElementById('map1'))
        let op11 = {
          backgroundColor: 'transparent',
          animation:false,
          tooltip: {
            trigger: 'item',
            backgroundColor:'none',
            padding:0,
            borderColor:'#078db9',
            formatter: (params, ticket, callback)=>{

                this.$httpservice.get("api/Equipment/Get",{id:params.data.value[2]}).then(res=>{
                  let data = res.body.data
                  console.log(res)
                  let context =  `
                    <div style="width: 300px;border-radius: 4px;text-align: left">
                      <div style="color: #fff;background-color: #0e5e96;line-height: 30px;padding-left: 5px;">${data.name}</div>
                      <div style="padding: 5px;overflow: hidden;background-color: rgba(7,105,188,0.4)">
                          <div style="float: left;width: 30%;height: 90px">
                              <img style="width: 100%;height: 100%;" src="data:image/png;base64,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"/>
                          </div>
                           <div style="float: left;width: 70%;line-height: 30px;color: #fff">
                              <div>型 号:${data.equipmentType?data.equipmentType.name:''}</div>
                              <div>状 态: ${data.equipmentNetworkStatus?'在线':'离线'}</div>
                              <div>投放地点:${(data.city?data.city:'')+(data.district?data.district:'')+(data.address?data.address:'')}</div>
                           </div>
                      </div>
                   </div>
                  `
                  callback(ticket,context)
                })


            }
          },
          bmap: {
            center: [104.114129, 37.550339],
            zoom: 5,
            roam: true,
            mapStyle: {
              styleJson: [
                {
                  "featureType": "water",
                  "elementType": "all",
                  "stylers": {
                    "color": "#021c3c"
                  }
                },
                {
                  "featureType": "land",
                  "elementType": "all",
                  "stylers": {
                    "color": "#003268"
                  }
                },
                {
                  "featureType": "boundary",
                  "elementType": "geometry",
                  "stylers": {
                    "color": "#0078b0"
                  }
                },
                {
                  "featureType": "railway",
                  "elementType": "all",
                  "stylers": {
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "highway",
                  "elementType": "geometry",
                  "stylers": {
                    "color": "#003268"
                  }
                },
                {
                  "featureType": "highway",
                  "elementType": "geometry.fill",
                  "stylers": {
                    "color": "#005b96",
                    "lightness": 1
                  }
                },
                {
                  "featureType": "highway",
                  "elementType": "labels",
                  "stylers": {
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "arterial",
                  "elementType": "geometry",
                  "stylers": {
                    "color": "#004981"
                  }
                },
                {
                  "featureType": "arterial",
                  "elementType": "geometry.fill",
                  "stylers": {
                    "color": "#00508b"
                  }
                },
                {
                  "featureType": "poi",
                  "elementType": "all",
                  "stylers": {
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "green",
                  "elementType": "all",
                  "stylers": {
                    "color": "#056197",
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "subway",
                  "elementType": "all",
                  "stylers": {
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "manmade",
                  "elementType": "all",
                  "stylers": {
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "local",
                  "elementType": "all",
                  "stylers": {
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "arterial",
                  "elementType": "labels",
                  "stylers": {
                    "visibility": "off"
                  }
                },
                {
                  "featureType": "boundary",
                  "elementType": "geometry.fill",
                  "stylers": {
                    "color": "#0078b0"
                  }
                },
                {
                  "featureType": "building",
                  "elementType": "all",
                  "stylers": {
                    "color": "#1a5787"
                  }
                },
                {
                  "featureType": "label",
                  "elementType": "all",
                  "stylers": {
                    "visibility": "off"
                  }
                }
              ]
            }
          },
          visualMap: {
            show: false,
            top: 'top',
            min: 0,
            max: 5,
            seriesIndex: 0,
            calculable: true,
            inRange: {
              color: ['#FFFFE0', 'yellow', 'yellow', '#FFD700', '#FFD700']
            }
          },
          series : [

            {
              type: 'heatmap',
              coordinateSystem: 'bmap',
              data: d5,
              pointSize: 5,
              blurSize: 6
            },
            {
              name: 'test1',
              type: 'scatter',
              coordinateSystem: 'bmap',
              data: d,
              encode: {
                value: 2
              },
              symbolSize: function (val) {
                return 3;
              },
              label: {
                formatter: '{b}',
                position: 'right'
              },
              itemStyle: {
                color: (params)=>{
                  if(params.value[3]){
                    return '#FFD700'
                  }else{
                    return '#FFD700'
                  }
                }
              },
              emphasis: {
                label: {
                  show: true
                }
              },
              z:2
            },
          ]
        }
        map1.setOption(op11)

        var bmap = map1.getModel().getComponent('bmap').getBMap()
        bmap.addEventListener("zoomstart",()=>{
          this.maplist = []
        })
        bmap.addEventListener("dragstart",()=>{
          this.maplist = []
        })



      },
      async getinfo(id){

      },
      //底下的十二月原料分类销售情况
      loadcharts7(){
        this.$httpservice.get("api/Analysis/BeverageCatalogMonthlySaleCount").then(
              (data) => {
                if(data.body.code=="200"){
                  // console.log(data.body.data)
                  // console.log(this.catalog1)
                  var data1 = data.body.data
                  var time = []
                  for(var i = 0;i<data1.length;i++){
                      switch (data1[i].beverageCatalog){
                        case 1 :
                          this.catalog1data.push(data1[i].count/10000)
                          time.push(data1[i].year+"年"+data1[i].month.toString()+"月")
                          break
                        case 2 :
                          this.catalog2data.push(data1[i].count/10000)
                          break
                        case 3 :
                          this.catalog3data.push(data1[i].count/10000)
                          break
                        case 4 :
                          this.catalog4data.push(data1[i].count/10000)
                          break
                      }
                  }
                  console.log(time)
                  for(var i = 0;i<12;i++){
                      this.average.push((this.catalog1data[i]+this.catalog2data[i]+this.catalog3data[i]+this.catalog4data[i])/4)
                  }
                  this.initcharts7(time)
                }else{
                  this.$message({
                    message: data.body.msg,
                    type: 'warning'
                  });
                }
              },
              (data) => {
                let statusCode = data.status;
                this.$message({
                  message: this.$t('queryFailedStatusCode')+statusCode,
                  type: 'warning'
                });
              }
            );
          },
      initcharts7(time){
        let line7 = this.$echarts.init(document.getElementById('line7'))
        let op10 = {
          legend: {
            data: ['咖啡', '奶茶', '豆浆','果汁'],
            top:0,
            right:20,
            textStyle:{
              color:'#a0d4f8'
            },
            icon:'roundRect',
            itemHeight:10,
            itemWidth:12
          },
           tooltip: {},
          grid:{
            left:'5%',
            top:40,
            right:40,
            bottom:20
          },
          xAxis: {
            type: 'category',
            name:'月份',
            boundaryGap: false,
            axisLabel:{
              color:'#92d1fc',
              interval:0
            },
            axisLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            splitLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            data: time
          },
          yAxis: {
            type: 'value',
            axisLabel:{
              color:'#92d1fc'
            },
            name:'销量（万杯）',
            nameGap:6,
            nameTextStyle:{
              color:'#efffff',
              align:'right'
            },
            splitLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
          },
          series: [
            {
              name:'咖啡',
              data: this.catalog1data,
              type: 'bar',
              itemStyle:{
                color:{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#29fcd3' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#43d264' // 100% 处的颜色
                  }],
                }
              }

            },
            {
              name:'奶茶',
              data: this.catalog2data,
              type: 'bar',
              itemStyle:{
                color:{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#2bb2ff' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#6d49e5' // 100% 处的颜色
                  }],
                }
              }

            },
            {
              name:'豆浆',
              data: this.catalog3data,
              type: 'bar',
              itemStyle:{
                color:{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#FAFAD2' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#FFFF00' // 100% 处的颜色
                  }],
                }
              }
            },
            {
              name:'果汁',
              data: this.catalog4data,
              type: 'bar',
              itemStyle:{
                color:{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#eb8e8e' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#da6161' // 100% 处的颜色
                  }],
                }
              }
            },
            {
              name:'平均',
              data: this.average,
              type: 'line',
              symbol:'none',
              itemStyle:{
                color:'#17c0f8',
              },
              lineStyle:{
                type:'dotted'
              },
              smooth:true,
            },
          ]
        }
        line7.setOption(op10)
      },

      loadcharts2(){
        this.$httpservice.get("api/Analysis/EquipmentNameCountRankingBySale").then(
          (res2) => {
            if(res2.body.code=="200"){
              this.initcharts55(res2.body.data)
            }else{
              this.$message({
                message: res2.body.msg,
                type: 'warning'
              });
            }
          },
          (data) => {
            let statusCode = data.status;
            this.$message({
              message: this.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        )
      },
      initcharts555(data){
        let x = []
        let y = []
        if(data.length>0){
          for(let i in data){
            x.push(data[i].beverage.name)
            y.push(data[i].count/10000)
          }
          this.firstBevarageName = data[0].beverage.name;
          this.firstBevarageCount = data[0].count;
          let line3 = this.$echarts.init(document.getElementById('line333'))
          let op9 = {
            grid:{
              left:'10%',
              top:30,
              right:20,
              bottom:20,
            },
            tooltip: {},
            xAxis: {
              type: 'category',
              data: x,
              axisLabel:{
                show:true,
                color:'#92d1fc',
                interval:0
              },
              axisLine:{
                lineStyle:{
                  color:'#02294d'
                }
              },
              splitLine:{
                lineStyle:{
                  color:'#02294d'
                }
              },
            },
            yAxis: {
              type: 'value',
              axisLabel:{
                color:'#92d1fc'
              },
              name:'数量（万杯）',
              nameGap:6,
              nameTextStyle:{
                color:'#efffff',
                align:'center'
              },
              splitLine:{
                lineStyle:{
                  color:'#02294d'
                }
              },
              axisLine:{
                lineStyle:{
                  color:'#02294d'
                }
              },
            },
            series: [
              // {
              //   data: [10, 20, 40, 30, 100],
              //   type: 'line',
              //   symbol:'none',
              //   itemStyle:{
              //     color:'#45b5ca',
              //   },
              // },
              {
                data: y,
                barWidth:8,
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(69, 181, 202, 0)',
                  borderWidth:8,
                  borderColor: 'rgba(69, 181, 202, 0.15)',
                },
                itemStyle:{
                  color:{
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#01b0ff' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#033dff' // 100% 处的颜色
                    }],
                  }
                }
              },
            ]
          }
          line3.setOption(op9)
        }
      },
      initcharts55(data){
        let x = []
        let y = []
        let imgs = [
          'image://data:image/png;base64,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',
          'image://data:image/png;base64,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'
        ]

        for(let i=0;i< data.length;i++){
          x.push(data[i].equipment.name)
          y.push({
            value:data[i].cupCount/10000,
            symbol:imgs[i%2]
          })

        }
        this.firstEquipName = data[0].equipment.name;
        this.firstEquipCount = data[0].cupCount;

        let line3 = this.$echarts.init(document.getElementById('line33'))
        let op9 = {
          grid:{
            left:'10%',
            top:30,
            right:20,
            bottom:40,
          },
          tooltip: {},
          xAxis: {
            type: 'category',
            data: x,
            axisLabel:{
              show:true,
              color:'#92d1fc',
              interval:0,
              rotate:15
            },
            axisLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            splitLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
          },
          yAxis: {
            type: 'value',
            axisLabel:{
              color:'#92d1fc'
            },
            name:'数量(万杯)',
            nameGap:6,
            nameTextStyle:{
              color:'#efffff',
              align:'center'
            },
            splitLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
          },
          series: [
            {
              data: y,
              type: 'bar',
              symbolRepeat: true,
              symbolSize: ['60%', '60%'],
              itemStyle:{
                normal:{
                  color:function(params){
                    let colors=[
                      {
                        color:{
                          type: 'linear',
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [{
                            offset: 0, color: '#29fcd3' // 0% 处的颜色
                          }, {
                            offset: 1, color: '#43d264' // 100% 处的颜色
                          }],
                        }
                      },
                      {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2bb2ff' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#6d49e5' // 100% 处的颜色
                        }],
                      },
                      {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#FAFAD2' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#FFFF00' // 100% 处的颜色
                        }],
                      },
                      {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#eb8e8e' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#da6161' // 100% 处的颜色
                        }]
                      },
                      {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#29fcd3' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#43d264' // 100% 处的颜色
                        }]
                      }
                    ]
                    return colors[params.dataIndex];
                  }
                }

              }
            }

          ]
        }
        line3.setOption(op9)
      },
      initcharts5(){
        let x = []
        let y = []
        for(let i in this.salewaylist){
          x.push(this.salewaylist[i].saleway.name)
          y.push(this.salewaylist[i].count)
        }
        let line3 = this.$echarts.init(document.getElementById('line3'))
        let op9 = {
          grid:{
            left:'10%',
            top:30,
            right:20,
            bottom:20,
          },
          tooltip: {},
          xAxis: {
            type: 'category',
            data: x,
            axisLabel:{
              show:true,
              color:'#92d1fc',
              interval:0
            },
            axisLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            splitLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
          },
          yAxis: {
            type: 'value',
            axisLabel:{
              color:'#92d1fc'
            },
            name:'金额:千万',
            nameGap:6,
            nameTextStyle:{
              color:'#efffff',
              align:'center'
            },
            splitLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
          },
          series: [
            {
              data: y,
              barWidth:8,
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(69, 181, 202, 0)',
                borderWidth:8,
                borderColor: 'rgba(69, 181, 202, 0.15)',
              },
              itemStyle:{
                color:{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#01b0ff' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#033dff' // 100% 处的颜色
                  }],
                }
              }
            },
          ]
        }
        line3.setOption(op9)
      },
      //原料销售排行
      loadchartnews4(){
        return this.$httpservice.get("api/Analysis/RawMaterialAndCupTypeSaleRanking?number=10").then(
          (res) => {
            if(res.body.code=="200"){
              //console.log(111)
              // console.log(res.body.data)
              this.chartnews4rank = res.body.data
              this.initcharts4(res.body.data)
            }else{
              this.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          (data) => {
            let statusCode = data.status;
            this.$message({
              message: this.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
   initcharts4(data){
        let x = []
        let y = []
        let x2 = []
        let y2 = []
        for(let i in data){
          x.push(data[i].rawMaterial.name)
          y.push((data[i].amount/1000).toFixed(2))
          y2.push((data[i].amount.count/10000).toFixed(2))
        }
        console.log(data)
        let line2 = this.$echarts.init(document.getElementById('line2'))

        let op6 = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['原料（kg）']
        },
        grid: {
            left:'10%',
            top:30,
            right:'5%',
            bottom:20
        },
        xAxis: [
          {
            type: 'category',
            splitLine:{
              lineStyle:{
                color:'#02294d'
              }
            },
            show:true,
            color:'#92d1fc',
            interval:0,
            rotate:15,
            boundaryGap: false,
            data: x
          }
        ],
        yAxis: [
          {
            name:'千克',
            type: 'value'
          }
        ],
        series: [
          {
            name: '消耗',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: y,
                          showBackground: true,
              backgroundStyle: {
                color: 'rgba(69, 181, 202, 0)',
                borderWidth:8,
                borderColor: 'rgba(69, 181, 202, 0.15)',
              },
              itemStyle:{
                color:{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#00376d96' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#77bbecd9' // 100% 处的颜色
                  }],
                }
              }
          }
        ]
      };
        line2.setOption(op6)
      },
      loadcharts3(){
        this.$httpservice.get("api/Analysis/BeverageSaleRanking").then(
          (res2) => {
            if(res2.body.code=="200"){
              this.charts4rank = res2.body.data
              this.initcharts555(res2.body.data)
            }else{
              this.$message({
                message: res2.body.msg,
                type: 'warning'
              });
            }
          },
          (data) => {
            let statusCode = data.status;
            this.$message({
              message: this.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        )
      },
      initcharts2(){
        let pie4 = this.$echarts.init(document.getElementById('pie4'))
        let op4 = {
          title: {
            show: true,
            text: "58%",
            x: "center",
            y: "center",
            textStyle: {
              fontSize: "1.4rem",
              color: "#08d3fc",
              fontWeight: "bold",
            },
          },
          series: {
            name: "",
            type: "pie",
            radius: ["56%", "70%"],
            avoidLabelOverlap: true,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 58,
                name: "",
                itemStyle: {
                  color:  {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: "#08d3fc" // 0% 处的颜色
                    }, {
                      offset: 1, color: '#2492d9' // 100% 处的颜色
                    }],
                  },
                },
              },
              {
                value: 42,
                name: "",
                itemStyle: {
                  color: "#072d5b",
                },
              },
            ],
          }
        }
        pie4.setOption(op4)
      },
      loadcharts1(){
        this.$httpservice.get("api/Analysis/CountOfIndividualEquipmentState").then(
          (res) => {
            if(res.body.code=="200"){
              this.charts1online = res.body.data.online
              this.charts1offline = res.body.data.offline
              this.charts1notactive = res.body.data.notActivated

              this.initcharts1(res.body.data)
            }else{
              this.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          (data) => {
            let statusCode = data.status;
            this.$message({
              message: this.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      initcharts1(data){
        let per1 = data.online/(data.offline + data.online + data.notActivated)
        let value1 = Math.floor(per1*10000)/100
        let text1 = value1 + '%'
        let pie1 = this.$echarts.init(document.getElementById('pie1'))
        let op1 = {
          title: {
            show: true,
            text: text1,
            x: "center",
            y: "center",
            textStyle: {
              fontSize: "1.4rem",
              color: "#08d3fc",
              fontWeight: "bold",
            },
          },
          series: {
            name: "",
            type: "pie",
            radius: ["65%", "85%"],
            avoidLabelOverlap: true,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: value1,
                name: "",
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: "#2bf8c8" // 0% 处的颜色
                    }, {
                      offset: 1, color: '#41d46b' // 100% 处的颜色
                    }],
                  },
                },
              },
              {
                value: (100-value1),
                name: "",
                itemStyle: {
                  color: "#072d5b",
                },
              },
            ],
          }
        }
        pie1.setOption(op1)

        let per2 = data.offline/(data.offline + data.online + data.notActivated)
        let value2 = Math.floor(per2*10000)/100
        let text2 = value2 + '%'
        let pie2 = this.$echarts.init(document.getElementById('pie2'))
        let op2 = {
          title: {
            show: true,
            text: text2,
            x: "center",
            y: "center",
            textStyle: {
              fontSize: "1.4rem",
              color: "#08d3fc",
              fontWeight: "bold",
            },
          },
          series: {
            name: "",
            type: "pie",
            radius: ["65%", "85%"],
            avoidLabelOverlap: true,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: value2,
                name: "",
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: "#d4afaf" // 0% 处的颜色
                    }, {
                      offset: 1, color: '#dc6666' // 100% 处的颜色
                    }],
                  },
                },
              },
              {
                value: (100-value2),
                name: "",
                itemStyle: {
                  color: "#072d5b",
                },
              },
            ],
          }
        }
        pie2.setOption(op2)

        let per3 = data.notActivated/(data.offline + data.online + data.notActivated)
        let value3 = Math.floor(per3*10000)/100
        let text3 = value3 + '%'
        let pie3 = this.$echarts.init(document.getElementById('pie3'))
        let op3 = {
          title: {
            show: true,
            text: text3,
            x: "center",
            y: "center",
            textStyle: {
              fontSize: "1.4rem",
              color: "#08d3fc",
              fontWeight: "bold",
            },
          },
          series: {
            name: "",
            type: "pie",
            radius: ["65%", "85%"],
            avoidLabelOverlap: true,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: value3,
                name: "",
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: "#cbc9f0" // 0% 处的颜色
                    }, {
                      offset: 1, color: '#6259e9' // 100% 处的颜色
                    }],
                  },
                },
              },
              {
                value: (100 - value3),
                name: "",
                itemStyle: {
                  color: "#3b7e9ca8",
                },
              },
            ],
          }
        }
        pie3.setOption(op3)
      },
    //杯型雷达图
    loadCupRado(){
        let that = this;
        this.$httpservice.get("api/Analysis/CupSizeSaleCountRanking").then(
          function (data) {
            if(data.body.code=="200"){

              that.cupRadoEcharts(data.body.data)
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: this.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
    cupRadoEcharts(data){
      var name = [];
      var value = [];
      let max = 0
      if(data.length>0){
        data.forEach(e=>{if(e.count>max){max = e.count}})
        data.forEach(e=>{
          name.push({text:e.cupSize.name+"/"+e.count+"杯",max:max})
          value.push(e.count)
        })
          var cupRadoChart = this.$echarts.init(document.getElementById('rado'));

          var option = {
                title: {
                  text: ''
                },
                legend: {
                  data: ['杯型销售情况']
                },
                tooltip:{},
                radar: {
                  // shape: 'circle',
                  indicator: name,
                  radius: 80,
                  axisName: {
                    formatter: '【{value}】',
                    color: '#ADD8E6',
                    borderRadius: 3,
                    fontSize:13,
                    padding: [5, 3,1,3]
                  }
                },
                series: [
                  {
                    name: '杯型销售情况1',
                    type: 'radar',
                    data: [
                      {
                        value: value,
                        areaStyle: {
                          color: 'rgba(65,105,225, 0.8)'
                        }
                      }
                    ]
                  }
                ]
              };
          cupRadoChart.setOption(option);
        }
      },

      bSort(arr) {
        var len = arr.length;
        for (var i = 0; i < len-1; i++) {
          for (var j = 0; j < len - 1 - i; j++) {
              if (arr[j].value < arr[j + 1].value) {
                  var temp = arr[j];
                  arr[j] = arr[j+1];
                  arr[j+1] = temp;
              }
          }
        }
        return arr;
      },
      //故障统计
      loadFaultInfoCount(){
        let that = this;
        return this.$httpservice.get("api/Analysis/FaultInfoCount",that.queryparam).then(
          function (data) {
            if(data.body.code=="200"){
              that.faultInfoList = data.body.data;
              that.queshuiFault = that.faultInfoList.filter(e=>e.type==0)[0].count
              that.quefenFault = that.faultInfoList.filter(e=>e.type==1)[0].count
              that.jspmFault = that.faultInfoList.filter(e=>e.type==2)[0].count
              that.jbccleanFault = that.faultInfoList.filter(e=>e.type==3)[0].count
              that.elseyunweiFault = that.faultInfoList.filter(e=>e.type==4)[0].count
              that.jiqiFault = that.faultInfoList.filter(e=>e.type==5)[0].count
              var chartdata = [
                { value: that.queshuiFault, name: '缺水故障' },
                { value: that.quefenFault, name: '缺粉故障' },
                { value: that.jspmFault, name: '接水盘满故障' },
                { value: that.jbccleanFault, name: '搅拌仓清洗故障' },
                { value: that.elseyunweiFault, name: '其他运维故障' },
                { value: that.jiqiFault, name: '设备故障' }
              ];
              that.paixuFaultdata = that.bSort(chartdata)
              that.faultEcharts()
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      //故障统计
      faultEcharts(){
        var faultInfoChart = this.$echarts.init(document.getElementById('baojing'));

        var faultInfooption = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            textStyle:{
              color:'#a0d4f8'
            },
            left: 'left',
            padding:[20,0,0,10],
          },

          series: [
            {
              type: 'pie',
              radius: '75%',
              center: ["65%", "53%"], 　　　　//这个属性调整图像的位置
              label:{            //饼图图形上的文本标签
                normal:{
                  show:true,
                  position:'inner', //标签的位置
                  textStyle : {
                    fontWeight : 300 ,
                    fontSize : 16    //文字的字体大小
                  },
                  formatter:'{d}%'
                }
              },
              data: this.paixuFaultdata,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
            }
          ]
        };
        faultInfoChart.setOption(faultInfooption);
      },
    }
  }
</script>

<style scoped>
  .s{
    float: left;
    width: 50%;
  }
  .sname{
    color: #17c0f8;
    font-size: 2.2rem;
    line-height: 3rem;
    text-align: left;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .snum .sc{
    background-image: url("../assets/images/largescreen/numback.png");
    background-size: 100% 100%;
    font-size: 2rem;
    line-height: 4rem;
    width: 130px;
    margin-right: 10px;
    color: #fffa49;
    float: left;
    font-weight: bold;
    text-align: center;
    position: relative;
    overflow: hidden;
    height: 4rem;
  }
  .numcss{
    position: absolute;
    display: inline-block;
    width: 3rem;
    height: 4rem;
    left: 0;
    top: 0;
  }
  .static{
    position: absolute;
    left: 10%;
    width: 80%;
    top:40px;
    z-index: 999999999;
  }
  .ctitle{
    padding-left: 10px;
    color: #17c0f8;
    font-size: 1.8rem;
    line-height: 2rem;
    border-left: 6px solid #17c0f8;
    text-align: left;
  }

  .tbody3{
    overflow: hidden;
    margin-top: 5px;
    border-left: 4px solid #01b0ff;
    background-color: rgba(39,133,221,0.3);
  }
  .tbody3 .td3{
    float: left;
    width: 33.33%;
    text-align: center;
    color: #a0d4f8;
    line-height: 3rem;
    font-size: 1.4rem;
  }
  .thead3{
    overflow: hidden;
  }
  .thead3 .th3{
    float: left;
    width: 33.33%;
    text-align: center;
    line-height: 3rem;
    font-size: 1.4rem;
    color: #17c0f8;
  }
  .rt3{
    display: flex;
    width: 100%;
    height: 100%;
  }
  .rt3l{
    flex-grow:2;
    flex-shrink:2;
    width: 1px;
    height: 100%;
  }
  .rt3r{
    flex-grow:3;
    flex-shrink:3;
    width: 1px;
    height: 100%;
  }

  .w25{
    width: 25% !important;
  }
  .rank3{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
  .rank3 .h3{
    flex-grow:1;
    flex-shrink:1;
    height: 1px;
    width: 100%;
  }

  .pt{
    text-align: center;
    line-height: 2rem;
    font-size: 1.4rem;
    color: #efffff;
  }
  .pb{
    background-image: url("../assets/images/largescreen/pb.png");
    background-size: 100% 100%;
    width: 100%;
    height: 10%;
  }
  .rank2{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
  }
  .vh{
    float: left;
    width: 50%;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .vh .t{
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
    color: #92d1fc;
    text-align: center;

  }
  .vh .v{
    text-align: center;
    font-size: 1.2rem;
    line-height: 3rem;
    color: #92d1fc;
    text-align: center;

  }
  .vh .v .num{
    font-size: 1.6rem;
    font-weight: bold;
    color: #08d3fc;
    margin-right: 3px;
  }
  .rinfo{
    box-shadow: 0 0 20px 10px rgba(7,105,188,0.45) inset;
    overflow: hidden;
  }
  .h{
    flex-grow:1;
    flex-shrink:1;
    height: 1px;
    width: 100%;
  }
  .rankl2{
    flex-grow:2;
    flex-shrink:2;
    width: 100%;
    height: 1px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .rankr2{
    background-image: url("../assets/images/pic29.png");
    flex-grow:3;
    flex-shrink:3;
    width: 100%;
    height: 1px;
  }
  .rank2 .rleft2{
    flex-grow:3;
    flex-shrink:3;
    width: 1px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .rank2 .rright2{
    flex-grow:7;
    flex-shrink:7;
    width: 1px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .ranki{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .rank1 .rcontent{
    float: left;
    width: 80%;
    height: 100%;
    padding-left: 10px;
  }
    .rank1 .rcontent1{
    float: left;
    width: 75%;
    height: 100%;
    padding-left: 10px;
  }
      .rank1 .rcontent2{
    float: left;
    width: 60%;
    height: 100%;
    padding-left: 10px;
  }
  .rank1 .rcontent .p{
    background-color: rgba(3,52,90,0.31);
    width: 100%;
    height: 100%;
    position: relative;
  }
  .p .rtitle{
    position: absolute;
    left: 5px;
    top: 10px;
    color: #efffff;
    font-size: 1.4rem;
  }
    .p .rtitle1{
    /* position: absolute; */
    left: 5px;
    top: 5px;
    /* color: #efffff; */
    font-size: 1.4rem;
    padding-top:5px;
        color: #ffcc48;
    font-size: 1.3rem;
    font-weight: bold;
  }
  .p .rvalue{
    position: absolute;
    bottom: 5px;
    right: 8px;
    color: #a0d4f8;
    font-size: 1.4rem;
  }
    .p .rvalue1{
    /* position: absolute;
    bottom: 5px;
    right: 20px; */
    color: #08d3fc;
    font-size: 1.4rem;
  }
  .p .rvalue .num{
    margin-right: 2px;
    font-size: 1.6rem;
    font-weight: bold;
    color: #08d3fc;
  }
  .ranki .icon1{
    float: left;
    width: 20%;
    height: 100%;
    background-image: url("../assets/images/largescreen/ranki1.png");
    background-size:60% 60%;
    background-position: center center;
    background-repeat: no-repeat;
    border: 1px solid;
    border-image: linear-gradient(to right bottom, #2dabe4,
    #165984) 1;
  }
  .ranki .icon11{
    margin-left: 36px;
    float: left;
    width: 15%;
    height: 100%;
    background-image: url("../assets/images/pic23.png");
    background-size:120% 120%;
    background-position: center center;
    background-repeat: no-repeat;

  }
    .ranki .icon12a{
    margin-left: 8px;
    float: left;
    width: 30%;
    height: 100%;
    background-image: url("../assets/images/pic27.png");
    background-size:100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
  }
    .ranki .icon12b{
    margin-left: 8px;
    float: left;
    width: 30%;
    height: 100%;
    background-image: url("../assets/images/pic28.png");
    background-size:100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .ranki .icon1.r1{
    background-image: url("../assets/images/one.png");
  }
   .pic23{
    background-image: url("../assets/images/rank1.png");
  }
  .ranki .icon1.r2{
    background-image: url("../assets/images/two.png");
  }
  .ranki .icon1.r3{
    background-image: url("../assets/images/three.png");
  }
  .ranki .icon1.r4{
    background-image: url("../assets/images/four.png");
  }


  .ranki .icon2{
    float: left;
    width: 30%;
    height: 100%;
    background-image: url("../assets/images/largescreen/ranki2.png");
    background-size: 100% 100%;
    border: 1px solid;
    border-image: linear-gradient(to right bottom, #2dabe4,
    #165984) 1;
  }
  .rank1{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
  .rank1 .top{
    flex-grow:1;
    flex-shrink:1;
    width: 100%;
    height: 1px;
    display: flex;
    flex-direction: column;
  }

    .rank1 .top1{
    flex-grow:0.5;
    flex-shrink:1;
    width: 100%;
    height: 1px;
    display: flex;
    flex-direction: column;
  }
  .line1{
    flex-grow:1;
    flex-shrink:1;
    width: 100%;
    height: 1px;
    display: flex;
    flex-direction: row;
    flex-wrap:wrap;
  }
  .col1{
    flex-grow:0;
    flex-shrink:1;
    width: 50%;
    height:50%;
    padding: 5px;
  }
    .col11{
    background-image: url("../assets/images/pic22.png");
    background-size:100% 100%;
    flex-grow:1;
    flex-shrink:1;
    width: 50%;
    height:100%;
    padding: 5px;
  }
      .col12{
    background-image: url("../assets/images/pic22.png");
    background-size:100% 100%;
    flex-grow:1;
    flex-shrink:1;
    width: 30%;
    height:100%;
    padding: 5px;
  }
  .rank1 .bottom{
    flex-grow:1;
    flex-shrink:1;
    width: 100%;
    height: 1px;
  }
 .rank1 .bottom1{
   background-image: url("../assets/images/pic29.png");
    flex-grow:1.5;
    flex-shrink:1;
    width: 100%;
    height: 1px;
  }

  .background{
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../assets/images/largescreen/background.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction:column;
  }
  .largehead{
    background-image: url("../assets/images/largescreen/topback.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 70px;
    width: 100%;
    flex-grow:1;
    flex-shrink:1;
    justify-content:center;
    align-items: center;
    flex-direction:column;
    position: relative;
  }

  .weather{
    position: absolute;
    top: 20px;
    right: 40px;
  }
  .weather .date{
    color: #efffff;
    font-weight: bold;
    font-size: 2rem;
    margin-right: 10px;
    display: inline-block;
  }
  .weather .week{
    color: #efffff;
    font-size: 2rem;
    display: inline-block;
    margin-right: 10px;
  }
  .weather .icon{
    color: #efffff;
    display: inline-block;
    margin-right: 10px;
  }
  .weather .icon img{
    width: 20px;
    height: 20px;
    vertical-align: bottom;
  }
  .weather .temperature{
    color: #efffff;
    font-size: 2rem;
    display: inline-block;
  }

  .headcenter{
    height: 100%;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow:1;
    flex-shrink:1;
  }
  .headcenterimg{
    height: 80%;
    vertical-align: top;
    margin-right: 30px;
  }
  .logoname{
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .loginnameitem{
    font-size: 2.8rem;
    color: #efffff;
    letter-spacing: 5px;
    font-weight: bold;
  }


  .largebody{
    width: 100%;
    height: 1010px;
    flex-grow:14.5;
    flex-shrink:14.5;
    flex-direction:row;
    display: flex;
  }

  .largebody .side{
    display: flex;
    flex-grow:1;
    flex-shrink:1;
    width: 1px;
    height: 100%;
    flex-direction: column;
    padding: 0 20px;
  }
  .largebody .side .item,.largebody .center .item{
    padding-bottom: 20px;
    display: flex;
    width: 100%;
    height: 1px;
    flex-grow:1;
    flex-shrink:1;
  }
  .largebody .center .item2{
    padding-bottom: 20px;
    display: flex;
    width: 100%;
    height: 1px;
    flex-grow:2;
    flex-shrink:2;
  }
  .largebody .center{
    display: flex;
    flex-grow:2;
    flex-shrink:2;
    width: 2px;
    height: 100%;
    flex-direction: column;
  }

  .item .title{
    width: 100%;
    background-image: url("../assets/images/largescreen/itemtitle.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: bottom;
    height: 2.5rem;
    text-align: left;
  }
  .item .title .name{
    color: #efffff;
    font-size: 1.8rem;
    margin-left: 20px;
    line-height: 2.5rem;
  }
  .item .title .more{
    float: right;
    line-height: 2.5rem;
    color: #9acbff;
    cursor: pointer;
    font-size: 1.5rem;
  }
  .item .panel{
    width: 100%;
    height: calc(100% - 2.5rem);
    background-color: rgba(4,15,40,0.15);
    box-shadow: 0 0 20px 20px rgba(19,119,194,0.2) inset;
    padding: 10px 20px;
  }

  .zxtj{
    position: relative;
    border: 1px solid #04365d;
    padding: 10px;
  }
  .zxtj .lefttop{
    position: absolute;
    left: 0;
    top: 0;
    width: 10px;
    height: 10px;
  }
  .zxtj .leftbottom{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    transform: rotate(-90deg);
  }
  .zxtj .righttop{
    position: absolute;
    right: 0;
    top: 0;
    width: 10px;
    height: 10px;
    transform: rotate(90deg);
  }
  .zxtj .rightbottom{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    transform: rotate(180deg);
  }
  .zxtj .zxtjcontent{
    height: 3rem;
    line-height: 3rem;
    box-shadow: 0 0 20px 10px rgba(7,105,188,0.45) inset;
  }
  .zxtj .zxtjcontent .txt1{
    text-align: center;
    float: left;
    width: 33.33%;
    font-size: 1.5rem;
    color: #92d1fc;
  }
  .zxtj .zxtjcontent .txt2{
    text-align: center;
    float: left;
    width: 33.33%;
    font-size: 1.8rem;
    color: #08d3fc;
    letter-spacing: 2px;
    font-weight: bold;
  }
  .lcharts{
    width: 100%;
    height: calc(100% - 20px - 3rem);
  }
  .lcharts .c{
    width: 100%;
    height: 50%;
    overflow: hidden;
  }
    .lcharts .cc{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .lcharts .c .pie{
    float: left;
    width: 33.33%;
    height: 100%;
    padding-top: 5px;
    text-align: center;
  }
  .lcharts .c .pie.border{
    border-right: 1px solid ;
    border-image: -webkit-linear-gradient( rgba(56,103,235,0), rgba(56,103,235,0) 40%, rgba(56,103,235,1),rgba(56,103,235,0) 60%,rgba(56,103,235,0)) 30 30;
    border-image: -moz-linear-gradient( rgba(56,103,235,0), rgba(56,103,235,0) 40%, rgba(56,103,235,1),rgba(56,103,235,0) 60%,rgba(56,103,235,0)) 30 30;
    border-image: linear-gradient(  rgba(56,103,235,0), rgba(56,103,235,0) 40%, rgba(56,103,235,1),rgba(56,103,235,0) 60%,rgba(56,103,235,0)) 30 30;
  }
    .lcharts .cc .pie{
    float: left;
    width: 33.33%;
    height: 100%;
    padding-top: 5px;
    text-align: center;
  }
  .lcharts .cc .pie.border{
    border-right: 1px solid ;
    border-image: -webkit-linear-gradient( rgba(56,103,235,0), rgba(56,103,235,0) 40%, rgba(56,103,235,1),rgba(56,103,235,0) 60%,rgba(56,103,235,0)) 30 30;
    border-image: -moz-linear-gradient( rgba(56,103,235,0), rgba(56,103,235,0) 40%, rgba(56,103,235,1),rgba(56,103,235,0) 60%,rgba(56,103,235,0)) 30 30;
    border-image: linear-gradient(  rgba(56,103,235,0), rgba(56,103,235,0) 40%, rgba(56,103,235,1),rgba(56,103,235,0) 60%,rgba(56,103,235,0)) 30 30;
  }
  .pie .piename{
    line-height: 1.5rem;
    font-size: 1.2rem;
    color: #efffff;
    text-align: center;
  }
  .pie .piecount{
    line-height: 1.5rem;
    font-size: 1.2rem;
    color: #08d3fc;
    text-align: center;
  }
  .pie .piecount .number{
    color: #ffcc48;
    font-size: 1.3rem;
    font-weight: bold;
    line-height: 1.5rem;
    vertical-align: top;
    margin-right: 5px;
  }
  .pie .process{
    height: calc(100% - 3rem);
  }

  .gzcl{
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
  }
  .gtop{
    flex-grow:1;
    flex-shrink:1;
    width: 100%;
    height: 1px;
  }

  .gtop .fl{
    float: left;
    width: 48%;
    height: 100%;
    background-image: url("../assets/images/largescreen/pl.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .gtop .fr{
    float: right;
    width: 48%;
    height: 100%;
    background-image: url("../assets/images/largescreen/pr.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .gcontent{
    width: 100%;
    padding-left: 50%;
    padding-top: 10px;
  }
  .gcontent .gtitle{
    color: #efffff;
    font-size: 1.4rem;
    line-height: 2rem;
  }
  .gcontent .gcount{
    color: #08dcfc;
    font-size: 1.2rem;
    line-height: 2rem;
  }
  .gcontent .gcount .gnum{
    font-size: 1.4rem;
    font-weight: bold;
    margin-right: 5px;
  }
  .gbottom{
    flex-grow:2;
    flex-shrink:2;
    width: 100%;
    height: 1px;
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .gbottom .gl{
    flex-grow:1;
    flex-shrink:1;
    height: 100%;
    width: 1px;
  }
  .gbottom .gr{
    width: 1px;
    flex-grow:2;
    flex-shrink:2;
    height: 100%;
  }
  .gchartstitle{
    height: 2.5rem;
    padding-top: 0.5rem;
    font-size: 1.4rem;
    line-height: 2rem;
    text-align: center;
    color: #efffff;
  }
  .gcharts{
    height: calc(100% - 2.5rem);
    background-image: url("../assets/images/largescreen/pieback.png");
    background-size: auto 100%;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .gtable{
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #04365d;
  }
  .gtable .lefttop{
    position: absolute;
    left: 0;
    top: 0;
    width: 10px;
    height: 10px;
  }
  .gtable .leftbottom{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    transform: rotate(-90deg);
  }
  .gtable .righttop{
    position: absolute;
    right: 0;
    top: 0;
    width: 10px;
    height: 10px;
    transform: rotate(90deg);
  }
  .gtable .rightbottom{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    transform: rotate(180deg);
  }
  .gtablethead{
    height: 3rem;
    background-color: rgba(3,52,90,0.31);
  }
  .gtablethead .th{
    line-height: 3rem;
    float: left;
    width: 33.33%;
    text-align: center;
    font-size: 1.6rem;
    color: #17c0f8;
  }
  .gtabletbody{
    height: calc(100% - 3rem);
  }
  .gitem{
    overflow: hidden;
  }
  .gitem .td{
    float: left;
    line-height: 3rem;
    width: 33.33%;
    text-align: center;
    font-size: 1.6rem;
    color: #a0d4f8;
  }

  .response{
    display: flex;
    flex-direction: column;

    height: 100%;
  }
  .rtop{
    flex-grow:1;
    flex-shrink:1;
    height: 1px;
    width: 100%;
  }
  .rbottom{
    flex-grow:2;
    flex-shrink:2;
    height: 1px;
    width: 100%;
  }
  .mycharts1{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .l1{
    padding: 10px;
  }
  .l1 .center{
    float: left;
    width: 70%;
    height: 2rem;
  }
  .l1 .center .process{
    margin-top: 0.5rem;
    height: 1rem;
    width: 100%;
    background-color: #1c4573;
    position: relative;
  }
  .othervalue{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-image: linear-gradient(to right, rgba(19,169,209,0.3) , rgba(19,169,209,1));
  }
  .minganvalue{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-image: linear-gradient(to right, rgba(203,103,30,0.3) , rgba(203,103,30,1));
  }

  .l1 .center .fg{
    width: 1%;
    height: 100%;
    background-color: #030d2b;
    position: absolute;
    top:0;
    z-index: 2;
  }
  .l1 .start{
    font-size: 1.6rem;
    line-height: 2rem;
    text-align: left;
    color: #efffff;
    float: left;
    width: 20%;
    height: 2rem;
  }
  .l1 .end{
    font-size: 1.6rem;
    line-height: 2rem;
    text-align: left;
    color: #13a9de;
    font-weight: bold;
    float: left;
    width: 10%;
    height: 2rem;
    text-align: right;
  }

  .gledge{
    text-align: right;
    height: 2rem;
  }
  .gledge .icon{
    display: inline-block;
    height: 1rem;
    vertical-align: top;
    margin-top: 0.5rem;
    width: 1.5rem;
    border-radius: 2px;
    margin-right: 2px;
    margin-left: 10px;
  }
  .gledge .iconname{
    font-size: 1.2rem;
    line-height: 2rem;
    color: #a0d4f8;
    display: inline-block;
  }


</style>
<style>
  @-webkit-keyframes animate1 {
    from {opacity: 0}
    to {opacity: 1}
  }
  @keyframes animate1 {
    from {opacity: 0}
    to {opacity: 1}
  }
  .animate{
    animation:animate1 0.5s ease 0s 1 forwards;
    -webkit-animation:animate1 0.5s ease 0s 1 forwards;
  }


  @-webkit-keyframes animate2 {
    0%  {top: 0}
    99% {top: -3rem}
    100% {top: -4rem}
  }
  @keyframes animate2 {
    0%  {top: 0}
    99% {top: -3rem}
    100% {top: -4rem}
  }
  .numberanimate{
    animation:animate2 0.5s ease 0s 1 forwards;
    -webkit-animation:animate2 0.5s ease 0s 1 forwards;
  }

  @-webkit-keyframes animate3 {
    0% {top: 4rem}
    1% {top: 3rem}
    100% {top: 0}
  }
  @keyframes animate3 {
    0% {top: 4rem}
    1% {top: 3rem}
    100% {top: 0}
  }
  .numberanimate2{
    animation:animate3 0.5s ease 0s 1 forwards;
    -webkit-animation:animate3 0.5s ease 0s 1 forwards;
  }
</style>



// WEBPACK FOOTER //
// src/pages/largeScreen.vue